const getSavedFilters = state => state.data.savedFilters;
const getSavedFilterName = (state, filterId) => state.data.savedFilters.get(filterId);

export default {
  getSavedFilters,
  getSavedFilterName
};
